(function () {
    'use strict';

    const TEAM_MANAGER_ORIGIN = 'https://edge-team-manager.netlify.app';

    function initialiseTeamManagerFrameSizing() {
        const frame = document.getElementById('team-manager-frame');
        if (!frame) return;

        let lastAppliedHeight = 340;

        frame.setAttribute('scrolling', 'no');
        frame.style.setProperty('overflow', 'hidden', 'important');
        frame.style.setProperty('height', '340px', 'important');
        frame.style.setProperty('min-height', '340px', 'important');
        frame.style.removeProperty('max-height');

        window.addEventListener('message', function (event) {
            if (event.origin !== TEAM_MANAGER_ORIGIN) return;
            if (event.source !== frame.contentWindow) return;
            if (event.data?.type !== 'edge-team-manager-height') return;

            /*
             * This dedicated handler owns Team Manager sizing.
             * Stop older bubble-phase listeners from applying a
             * second height and creating a resize feedback loop.
             */
            event.stopImmediatePropagation();

            const requestedHeight = Number(event.data.height);
            if (!Number.isFinite(requestedHeight) || requestedHeight <= 0) return;

            const height = Math.max(340, Math.ceil(requestedHeight));

            if (Math.abs(height - lastAppliedHeight) < 2) return;

            lastAppliedHeight = height;

            frame.style.setProperty('height', `${height}px`, 'important');
            frame.style.setProperty('min-height', '340px', 'important');
        }, true);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialiseTeamManagerFrameSizing);
    } else {
        initialiseTeamManagerFrameSizing();
    }
})();
